import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mb-16 xl:max-w-none" }
const _hoisted_2 = { class: "not-prose grid grid-cols-1 gap-8 sm:grid-cols-2 xl:grid-cols-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BeakerIcon = _resolveComponent("BeakerIcon")!
  const _component_QuickLink = _resolveComponent("QuickLink")!
  const _component_BoltIcon = _resolveComponent("BoltIcon")!
  const _component_ArrowDownTrayIcon = _resolveComponent("ArrowDownTrayIcon")!
  const _component_MapIcon = _resolveComponent("MapIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_QuickLink, {
        toColor: "dark:to-[#1f5c6e]",
        title: "Examples",
        to: _ctx.examplesRoute
      }, {
        icon: _withCtx(() => [
          _createVNode(_component_BeakerIcon, { class: "w-4" })
        ]),
        text: _withCtx(() => [
          _createTextVNode(" Learn from examples scenes. Many nodes have comments making them easy to understand. ")
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["to"]),
      _createVNode(_component_QuickLink, {
        toColor: "dark:to-[#582157]",
        title: "Integrations",
        to: _ctx.integrationsRoute
      }, {
        icon: _withCtx(() => [
          _createVNode(_component_BoltIcon, { class: "w-4" })
        ]),
        text: _withCtx(() => [
          _createTextVNode(" Add Polygonjs scenes to any project, whether you use vue, react, vanilla or any other tool. ")
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["to"]),
      _createVNode(_component_QuickLink, {
        toColor: "dark:to-[#1b6c11]",
        title: "Install",
        to: _ctx.installRoute
      }, {
        icon: _withCtx(() => [
          _createVNode(_component_ArrowDownTrayIcon, { class: "w-4" })
        ]),
        text: _withCtx(() => [
          _createTextVNode(" Install Polygonjs locally and create 3D scenes even faster. ")
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["to"]),
      _createVNode(_component_QuickLink, {
        toColor: "dark:to-[#894822]",
        title: "Nodes",
        to: _ctx.nodesRoute
      }, {
        icon: _withCtx(() => [
          _createVNode(_component_MapIcon, { class: "w-4" })
        ]),
        text: _withCtx(() => [
          _createTextVNode(" Check out the available nodes to get a sense of the infinite possibilities. ")
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["to"])
    ])
  ]))
}